import { types } from '@actions/transcripts';
import { mapPaginationValues } from '@services/dashboardResource';
import { initialState } from '@reducers/conferences';

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.CLEAN_TRANSCRIPTS:
      return {
        ...initialState,
      };
    case types.GET.LIST.STARTED:
      return {
        ...state,
        isFetching: true,
      };
    case types.GET.LIST.SUCCESS:
      return {
        ...state,
        list: action.list,
        ...mapPaginationValues(action.meta),
        isFetching: false,
      };
    case types.GET.LIST.FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case types.GET.CLOUD_SEARCH_LIST.STARTED:
      return {
        ...state,
        isFetching: true,
        isCloudSearchResults: true,
      };
    case types.GET.CLOUD_SEARCH_LIST.SUCCESS:
      return {
        ...state,
        list: action.list,
        total: null,
        isFetching: false,
      };
    case types.GET.CLOUD_SEARCH_LIST.FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case types.SET_TRANSCRIPTS_FILTER:
      return {
        ...state,
        [action.field]: action.value,
      };
    case types.SET_TRANSCRIPTS_ORDER:
      return {
        ...state,
        [action.field]: action.value,
      };
    case types.GET.TRANSCRIPT_RECORDINGS_LINKS.STARTED:
      return {
        ...state,
        signedUrls: {
          isFetching: true,
        },
      };
    case types.GET.TRANSCRIPT_RECORDINGS_LINKS.SUCCESS:
      return {
        ...state,
        signedUrls: {
          isFetching: false,
          recordings: action.payload,
        },
      };
    case types.GET.TRANSCRIPT_RECORDINGS_LINKS.FAILURE:
      return {
        ...state,
        signedUrls: {
          isFetching: false,
        },
      };
    case types.GET.TRANSCRIPT_RECORDINGS_LINKS.CLEAR:
      return {
        ...state,
        signedUrls: {
          isFetching: false,
          recordings: [],
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/transcripts.js